export const categories = [
  {
    slug: 'movie',
    name: '影视资源',
    icon: 'ri-movie-2-line',
    description: '最新电影、经典影片、剧集资源，涵盖动作、喜剧、科幻、悬疑等全类型',
    count: 28560,
    color: 'primary',
    keywords: ['电影', '电视剧', '动漫', '纪录片', '综艺'],
  },
  {
    slug: 'music',
    name: '音乐资源',
    icon: 'ri-music-2-line',
    description: '无损音乐、热门专辑、演唱会资源，覆盖流行、摇滚、古典、电子等风格',
    count: 19420,
    color: 'accent',
    keywords: ['无损音乐', '专辑', '演唱会', 'MV', '原声带'],
  },
  {
    slug: 'software',
    name: '软件资源',
    icon: 'ri-computer-line',
    description: '操作系统、办公软件、设计工具、开发工具等实用软件资源合集',
    count: 12850,
    color: 'secondary',
    keywords: ['系统工具', '办公软件', '设计工具', '编程开发', '安全软件'],
  },
  {
    slug: 'game',
    name: '游戏资源',
    icon: 'ri-gamepad-line',
    description: 'PC游戏、主机游戏、手游资源，涵盖动作冒险、角色扮演、策略等类型',
    count: 22100,
    color: 'primary',
    keywords: ['PC游戏', '主机游戏', '手游', '独立游戏', '模拟器'],
  },
  {
    slug: 'ebook',
    name: '电子书籍',
    icon: 'ri-book-open-line',
    description: '电子书、漫画、杂志、学习资料，覆盖文学、科技、教育、生活等领域',
    count: 16780,
    color: 'accent',
    keywords: ['电子书', '漫画', '杂志', '教材', '学术论文'],
  },
  {
    slug: 'other',
    name: '其他资源',
    icon: 'ri-folder-3-line',
    description: '素材模板、课程教程、资料合集等各类综合资源，满足多样化需求',
    count: 9350,
    color: 'secondary',
    keywords: ['素材模板', '教程视频', '资料合集', '设计素材', '摄影作品'],
  },
];

export const categorySlugs = categories.map((c) => c.slug);